module.exports = __webpack_public_path__ + "img/arrow-gray.0e26d969.svg";